import React from 'react';
import './ScrollArrow.css';

function ScrollArrow() {
  const scrollToNext = () => {
    const homeHero = document.querySelector('.home-hero');
    const header = document.querySelector('.header');
    
    if (homeHero && header) {
      const nextSection = homeHero.nextElementSibling;
      if (nextSection) {
        const headerHeight = header.offsetHeight;
        const nextSectionTop = nextSection.getBoundingClientRect().top + window.scrollY;
        const targetPosition = nextSectionTop - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <button 
      className="scroll-arrow visible"
      onClick={scrollToNext}
      aria-label="Scroll down"
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
      >
        <path 
          d="M7 10L12 15L17 10" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default ScrollArrow;

